// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-edab68b4]{display:flex;display:-webkit-flex;justify-content:center;align-items:flex-start}.content .info[data-v-edab68b4]{width:50%;border-right:1px solid #4e5359}.content .info[data-v-edab68b4]:last-child{border-right:none}.content .info .info-title[data-v-edab68b4]{font-size:18px;color:#4e5359;text-align:center;padding-bottom:20px}.content .el-form .el-form-item[data-v-edab68b4]{margin-left:40px;width:80%}", ""]);
// Exports
module.exports = exports;
